import { defineStore, getActivePinia } from "pinia";
import { useAvatarFormStore } from "./avatarForm/avatarForm";
import { useAuthInfoFormStore } from "./authInfoform/authInfoForm";
import { useUserFavoriteContactStore } from "./favoriteContactForm/userFavoriteContactForm";
import { useUserInfoFormStore } from "./userInfoForm/userInfoForm";
import { computed, ref } from "vue";
import { useCompanyDetailStore } from "./companyDetailsForm/useCompanyDetailsForm";
import { navigate } from "vike/client/router";

export const useProfileStore = defineStore('user-profile', () => {
    const avatarFormStore = useAvatarFormStore()
    const authInfoFormStore = useAuthInfoFormStore()
    const userFavoriteContactStore = useUserFavoriteContactStore()
    const userInfoFormStore = useUserInfoFormStore()
    const companyDetailStore = useCompanyDetailStore()
    const leaveWithoutSaving = ref(false)
    const blockingPageLeave = ref(false) // flag to avoid infinite loop on profile rerender when there are changes
    const onProfilePage = ref(false)

    const pinia = getActivePinia()

    const hasChanges = computed(() => {
        return (
            avatarFormStore.hasChanges ||
            authInfoFormStore.hasChanges ||
            userFavoriteContactStore.hasChanges ||
            userInfoFormStore.hasChanges ||
            companyDetailStore.hasChanges
        )
    })

    const clearData = () => {
        avatarFormStore.clearData()
        authInfoFormStore.clearData()
        userFavoriteContactStore.clearData()
        userInfoFormStore.clearData()
        companyDetailStore.clearData()
        leaveWithoutSaving.value = false
        blockingPageLeave.value = false
        onProfilePage.value = false
    }

    const resetFormStores = () => {
        avatarFormStore.$dispose()
        delete pinia?.state.value[avatarFormStore.$id]

        authInfoFormStore.$dispose()
        delete pinia?.state.value[authInfoFormStore.$id]

        userFavoriteContactStore.$dispose()
        delete pinia?.state.value[userFavoriteContactStore.$id]

        userInfoFormStore.$dispose()
        delete pinia?.state.value[userInfoFormStore.$id]

        companyDetailStore.$dispose()
        delete pinia?.state.value[companyDetailStore.$id]
    }

    const handleSaveChangesBeforeLeaving = async (pageContext: any) => {
        const profileStore = useProfileStore()
        if (profileStore.hasChanges && !profileStore.blockingPageLeave && profileStore.onProfilePage) {
            if (window.event?.type === 'popstate') {
                if (!profileStore.leaveWithoutSaving && profileStore.hasChanges) {
                    const elem: any = document.getElementById('modalbutton');
                    elem?.click();
                    profileStore.blockingPageLeave = true // set it to true to avoid infinite loop
                    await navigate(`/cs/profil?destination=${pageContext.urlPathname}`)
                } else {
                    profileStore.resetFormStores()
                    profileStore.clearData()
                    profileStore.$dispose()
                    // delete pinia?.state.value[profileStore.$id]
                }
            } else {
                if (!profileStore.leaveWithoutSaving && profileStore.hasChanges) {
                    const elem: any = document.getElementById('modalbutton');
                    elem?.click();
                    profileStore.blockingPageLeave = true // set it to true to avoid infinite loop
                    await navigate(`/cs/profil?destination=${pageContext.urlPathname}`)
                } else {
                    profileStore.resetFormStores()
                    profileStore.clearData()
                    profileStore.$dispose()
                    // delete pinia?.state.value[profileStore.$id]
                }
            }
        }
    }

    return {
        hasChanges,
        resetFormStores,
        clearData,
        handleSaveChangesBeforeLeaving,
        leaveWithoutSaving,
        blockingPageLeave,
        onProfilePage
    }
})